export default __webpack_public_path__ + "df4c7aca8b2807ac0ede00d17e9c0f85.png";